<template>
  <div class="meta-sources-wrap">
    <el-form>
    <el-form-item label="Пользователи" prop="users">
      <br>
      <el-select
        v-model="usersForm.all"
        multiple
        filterable
        placeholder="Выберите пользователей"
        style="width: 350px"
      >
        <el-option
          v-for="user in users"
          :key="user.uid"
          :label="user.username"
          :value="user.username"
        />
      </el-select>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" @click="addThreadUser">Сохранить изменения</el-button>
    </el-form-item>
    </el-form>
  </div>
</template>

<script>
  /*
    Meta source component
  */

  // api
  import { getThreadUsersApi, setThreadUsersApi } from "../../../../../api/feeds";


  export default {
    name: 'ThreadUsers',
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        displayUsers: false,
        usersForm: {
          users: [],
          all: []
        },
      };
    },
    computed: {
      users() {
        return this.$store.getters['users']
      },
    },
    methods: {
      getThreadUsers() {
        this.$nextTick( () => {
          getThreadUsersApi({thread_id: +this.$route.params.threadId}).then((resp) => {
            this.usersForm.users.push(...resp.data)
            this.usersForm.users.map((it)=>{
              this.usersForm.all.push(it.username)
            })
          });
        })
      },
      addThreadUser() {
        let usersArr = [];
        this.users.forEach(item => {
          if ( this.usersForm.all.includes(item.username)) {
            usersArr.push(+item.uid);
          }
        });
        let userParams = {
          thread_id: this.$route.params.threadId,
          users: usersArr,
        }

        setThreadUsersApi(userParams).then(() => {
          notify.call(this, "Список пользователей изменен", "success");
          this.$store.dispatch(GET_FEEDS);
        });
      },
      getDisabled(source) {
        if (source.disabled === undefined) {
          return true;
        }

        return source.disabled;
      },
      toEdit(source) {
        if (source.disabled === undefined) {
          this.$set(source, 'disabled', false);
        } else {
          source.disabled = !source.disabled;
        }
      },
      setSelectedSource({select, net, sourceId}) {
        if (this.selectedSource[sourceId]) {
          this.selectedSource[sourceId] = {...this.selectedSource[sourceId], ...{[net]: select.toString()}};
        } else {
          this.selectedSource = {[sourceId]: {[net]: select.toString()}};
        }
      },
      getKeyData(sourceId, source) {
        let keysData = {};

        for (let key in this.sourcesDictionary) {
          if (this.selectedSource[sourceId][key]) {
            keysData[key] = this.selectedSource[sourceId][key];
          } else {
            keysData[key] = source[key].id;
          }
        }

        return keysData;
      },
      toSave(sourceId) {
        this.loading = true;
        let source = this.sources.find(item => item.id === sourceId);

        let params = {
          id: source.id,
          thread_id: this.$route.params.threadId,
          title: source.title,
          ...this.getKeyData(sourceId, source),
          tg: '',
        };

        saveMetaItemApi(params).then(resp => {
          this.sources = this.sources.map(item => {
            if (item.id === resp.data.id) {
              item = {...item, ...resp.data};
            }

            return item;
          });
          this.loading = false;
        });

      },
      saveNewSource(params) {
        this.loading = true;
        this.metaDrawer = false;

        saveMetaItemApi(params).then(resp => {
          this.sources.push(resp.data);
          this.loading = false;
        });
      },
      toDelete(sourceId) {
        this.$alert(`Удалить мета-источник?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.loading = true;

              deleteMetaItemApi({id: sourceId}).then(() => {
                this.sources = this.sources.filter(item => item.id !== sourceId);
                this.loading = false;
              });

            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      getType(source) {
        if (source.disabled === undefined) {
          return 'primary';
        }

        if (source.disabled === false) {
          return '';
        } else {
          return 'primary';
        }
      },
      getTitle(source) {
        if (source.disabled === undefined) {
          return this.$t('feed.settings.metaSource.editForm.editButton');
        }

        if (source.disabled === false) {
          return this.$t('feed.settings.metaSource.editForm.cancelButton');
        } else {
          return this.$t('feed.settings.metaSource.editForm.editButton');
        }
      },
      getSources() {
        this.loading = true;
        this.activeSource = '';

        getThreadUsersApi({
          thread_id: this.$route.params.threadId,
          start: this.start,
          limit: this.limit,
        }).then(resp => {
          getSourcesByNetApi({thread_id: this.$route.params.threadId}).then(netResp => {
            this.isLoaded = true;
            this.loading = false;

            this.sourcesByNet = netResp.data;
            this.sources = [...this.sources, ...resp.data.items];
            this.start = this.sources.length;

            //console.log(resp, netResp);
          });
        });
      }
    },
    mounted() {
      this.getThreadUsers();

    },
  };
</script>

<style>
  .meta-source-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .meta-source-list .el-input-group__prepend {
    width: 35px;
    text-align: center;
  }
  .meta-source-list__item {
    margin-bottom: 20px;
  }
  .meta-source-list .el-select{
    display: block;
  }
  .meta-sources-button-wrap {
    display: flex;
  }
</style>
